import React from 'react';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';

import withTranslations from 'app/components/HOGs/withTranslations';
import { decodeSpecLetters, getUserLink } from 'app/components/Utility/utility';

const CreatedBy = ({ tr }) => {
  const data = useSelector((store) => store.placesData.data);
  const isEditMode = useSelector((store) => store.placesData.isEditMode);
  const { user = {} } = data;

  return !isEditMode && user ? (
    <span className="createBy">
      {`${tr.by} `}
      <Link to={getUserLink(user)}>{decodeSpecLetters(user.name)}</Link>
    </span>
  ) : null;
};

export default withTranslations(CreatedBy);
